import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/mediabook/mediabook/src/templates/Standalone.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1>{`Career, Internship, and Job Placement Services`}</h1>
    <p>{`Make School provides Career Services to assist current students and graduates in developing job
search skills such as resume and cover letter development, interviewing skills, and appropriate
interview follow-up activities. Make School organizes career-preparation events including talks,
networking events, career fairs, and demo days with industry members to broaden students’
professional networks and increase their access to potential employers. During their time at Make
School, students have the ability to participate in on-site visits to local potential employers, and
build an online portfolio to be showcased during recruitment opportunities. We encourage students to
utilize platforms such as Handshake and join the Make School Connect group on LinkedIn. Make School
also makes personal introductions to recruiters and companies for well-qualified students seeking
internships and full-time employment.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      